// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2PlNc","title":"AfterFrontImage_title__3Yg49"};